import React, { useState } from 'react'
import styled from 'styled-components'
import CrossDark from '../../../../../components/Images/CrossDark'
import { Popup } from '../../../../../components/Popup'
import { Box, Button } from '../../../../../designSystem'
import '../chapterAddEdit.css'

const StyledHeading = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  text-align: center;
  color: rgba(48, 48, 48, 1);
`

const StyledCheckboxText = styled.p`
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: rgba(128, 128, 128, 1);
  margin-left: 8px;
  span {
    color: rgba(0, 163, 255, 1);
  }
`

const StyledButtonBoxes = styled.div`
  margin-top: 16px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  gap: 16px;
`

function StoryConfirmPublishPopup({
  confirmStoryPopup,
  toggleConfirmStoryPopup,
  handleStoryPublish,
}) {
  const [isAgreed, setIsAgreed] = useState(true)
  return (
    <Popup
      show={confirmStoryPopup}
      close={() => toggleConfirmStoryPopup(false)}
    >
      <Box display="flex" justifyContent="flex-end">
        <CrossDark onClick={() => toggleConfirmStoryPopup(false)} />
      </Box>
      <Box variant="flex" alignItems="center" mb={8} justifyContent="center">
        <StyledHeading>Do you want to finally publish the story</StyledHeading>
      </Box>
      <Box>
        <Box display="flex" my={16}>
          <input
            id="terms"
            type="checkbox"
            name="terms"
            value="on"
            onChange={() => setIsAgreed(!isAgreed)}
            checked={isAgreed}
          />
          <StyledCheckboxText>
            I agree with <a href="/content-and-community-guidelines" target="_blank"><span>Content & Community Guidelines</span></a>
          </StyledCheckboxText>
        </Box>
      </Box>
      <StyledButtonBoxes>
        <Button
          variant="outlinePrimary"
          width="100%"
          onClick={() => toggleConfirmStoryPopup(false)}
        >
          Cancel
        </Button>
        <Button
          width="100%"
          disabled={!isAgreed}
          onClick={() => {
            toggleConfirmStoryPopup(false)
            handleStoryPublish()
          }}
        >
          Publish
        </Button>
      </StyledButtonBoxes>
    </Popup>
  )
}

export default StoryConfirmPublishPopup
